export default [
  {
    path: "/config",
    props: true,
    component: () => import("../Main.vue")
  }
]
